import $ from 'jquery';

$(document).ready(() => {
    if($('.dlWrapper').length) {
        $('.dlWrapper').each((i, e) => {
            $(e).attr('download', $(e).attr('data-downloadname'));
        });
    }
});

// Remove once old blocks are replaced
$(document).ready(() => {
    if($('#dlWrapper').length) {
        $('#dlWrapper').each((i, e) => {
            $(e).attr('download', $(e).attr('data-downloadname'));
        });
    }
});